<template>
  <div class="tag-add">
    <el-dialog
      title="添加学生标签"
      :visible="dialogVisible"
      @open="dialogOpen"
      @close="dialogClose"
      width="750px"
      :close-on-click-modal="false"
      center
    >
      <div class="dialog-btn" v-show="!isSelectMode">
        <el-button type="primary" @click="conditionalScreen"
          >根据条件筛选</el-button
        >
        <el-button type="primary" @click="designatedStudent"
          >选择指定学生</el-button
        >
      </div>
      <div v-show="isSelectMode">
        <conditionalScreen
          :isSelectMode.sync="isSelectMode"
          :gradeExamInfoList="gradeExamInfoList"
          v-if="mode == 'conditionalScreen'"
          @tagStudentSubmit="tagStudentSubmit"
        />
        <designatedStudent
          v-if="mode == 'designatedStudent'"
          :isSelectMode.sync="isSelectMode"
          :schoolGradeData="schoolGradeData"
          @tagStudentSelectSubmit="tagStudentSelectSubmit"
        />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import conditionalScreen from "../conditional-screen/conditionalScreen.vue";
import designatedStudent from "../designated-student/designatedStudent.vue";
export default {
  name: "",
  props: {
    dialogVisible: {
      type: Boolean,
      require: true,
    },
    gradeExamInfoList: {
      type: Array,
      require: true,
    },
    schoolGradeData: {
      type: Array,
      require: true,
    },
  },
  components: {
    conditionalScreen,
    designatedStudent,
  },
  data() {
    return {
      isSelectMode: false,
      mode: "",
    };
  },
  inject: ["refresh"],
  created() {},
  methods: {
    dialogOpen() {},
    dialogClose() {
      this.mode = "";
      this.isSelectMode = false;
      this.$emit("update:dialogVisible", false);
    },
    conditionalScreen() {
      this.isSelectMode = true;
      this.mode = "conditionalScreen";
    },
    designatedStudent() {
      this.isSelectMode = true;
      this.mode = "designatedStudent";
    },
    // 添加标签点击确认(筛选学生方式)
    tagStudentSubmit(data) {
      this.$emit("tagStudentSubmit", data);
    },
    // 添加标签点击确认(选择学生方式)
    tagStudentSelectSubmit(data) {
      this.$emit("tagStudentSelectSubmit", data);
    },
  },
};
</script>

<style lang="scss" scoped >
@import "./student-tag-add.scss";
</style>